import { useContext } from "react"
import { AppContext } from "../App"
import { MdHome, MdLogout, MdMenu, MdNotifications, MdOutlineLibraryBooks, MdOutlineMessage, MdOutlineNotifications } from "react-icons/md";
import { IoNotificationsOutline, IoRefreshCircleOutline } from "react-icons/io5";
import { TbMessageDots, TbReportAnalytics } from "react-icons/tb";
import { callApi, setCookie } from "../Helpers";
import { AiOutlineMessage, AiOutlineUser } from 'react-icons/ai';
import { STR__MENU_BOOKINGS, STR_ACCOUNT, STR_CONTACTS, STR_LEARN, STR_LEARN_2, STR_MENU_DATING, STR_MENU_DOCTORS, STR_MENU_HOME, STR_MENU_HOTELS, STR_MENU_INBOX, STR_MESSAGES, STR_TRACK } from "../Strings";
import { RiContactsBookLine, RiHome6Fill, RiHome6Line, RiHomeLine, RiHotelLine } from 'react-icons/ri';
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { LiaSchoolSolid } from "react-icons/lia";
import { CgProfile } from "react-icons/cg";
import { GrUserSettings } from "react-icons/gr";
import { FaRegUser } from "react-icons/fa";


export default function BottomBar(props) {

  const appContext = useContext(AppContext);

  return (
    <div
      className="BottomBar"
    >
      <div className="d-flex justify-content-between" style={{ height: "100%" }}>

        <div
          className="mIcon text-center"
          data-active={appContext.navItem === 'home' || !appContext.navItem}
          onClick={() => {
            appContext.navTo({
              item: 'home',
            })
          }}
        >
          <RiHome6Line className="mSymbol" />
          <h6 className="mText">{STR_MENU_HOME[appContext.language]}</h6>
        </div>

        

        <div
          className="mIcon text-center"
          data-active={appContext.navItem === 'account'}
          onClick={() => {
            appContext.navTo({
              item: 'account',
            })
          }}
        >
          <FaRegUser className="mSymbol" />
          <h6 className="mText">{STR_ACCOUNT[appContext.language]}</h6>
        </div>



      </div>
    </div>
  )
}